<template>
  <div class="space-y-4">
    <ul
      v-if="!loading && hasOffers"
      class="border border-gray-400 rounded bg-white divide-y bg-clip-padding"
    >
      <li
        v-for="offer in offers"
        :key="offer.uuid"
        class="odd:bg-gray-50 hover:bg-gray-100 first:rounded-t last:rounded-b cursor-default"
      >
        <OfferLine :offer="offer" />
      </li>
    </ul>

    <OfferCreateModalForm
      v-if="$isAdminOrSuperAdmin && contactRequest.contactId"
      :account-id="contactRequest.accountId"
      :default-form-data="{
        contactId: contactRequest.contactId,
        contactRequestId: contactRequest.id,
      }"
      can-update-issuer
      @success="refreshOffers"
    />
    <div v-else-if="$isAdminOrSuperAdmin && !contactRequest.contactId">
      Requires Linked Contact before creating an offer.
    </div>
  </div>
</template>

<script>
import OfferCreateModalForm from 'Forms/OfferModalForm/Create.vue';
import OfferLine from './OfferLine.vue';

export default {
  components: {
    OfferCreateModalForm,
    OfferLine,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    offers() {
      return this.$store.getters['ui/contactRequestOffers/itemsByParent'](this.contactRequest.id);
    },
    hasOffers() {
      return this.offers.length > 0;
    },
  },
  created() {
    this.loadOffers();
  },
  methods: {
    setLoading(value) {
      this.loading = Boolean(value);
    },
    getOffers() {
      return this.$store.dispatch({
        type: 'ui/contactRequestOffers/load',
        id: this.contactRequest.id,
      });
    },
    async loadOffers() {
      try {
        this.setLoading(true);
        await this.getOffers();
      } catch (error) {
        //
      } finally {
        this.setLoading(false);
      }
    },
    async refreshOffers() {
      try {
        await this.getOffers();
      } catch (error) {
        //
      }
    },
  },
};
</script>
